// The "legacy exposes to TS" half of the bridge: openEventDialog/toastTemporary/cb/DATE_USED stay
// defined in js/calendar.v2.8.js (dialog rewrite is a separate future step; DATE_USED is set by
// calendar.php on every refresh) and are called into from the new context menu. Mirrors
// legacy-bridge.ts's existing "TS exposes to legacy" bridge, in the other direction.

declare global {
  interface Window {
    openEventDialog?: (url: string) => void;
    toastTemporary?: (message: string, isError: boolean) => void;
    cb?: (start: unknown, end: unknown) => void;
    dayjs?: (value?: string | null) => unknown;
    i18n?: Record<string, string>;
  }
  // eslint-disable-next-line no-var
  var DATE_USED: string | undefined;
}

export function t(key: string, fallback: string): string {
  return window.i18n?.[key] ?? fallback;
}

export function openEventDialog(url: string): void {
  window.openEventDialog?.(url);
}

export function toast(message: string, isError: boolean): void {
  window.toastTemporary?.(message, isError);
}

// Same redraw path calendar.v2.8.js's undo success handler uses: clear the cached-request keys,
// then redraw through the legacy callback (falling back to a full reload if it's ever unavailable).
export function redrawCalendar(): void {
  sessionStorage.removeItem('previousRequest');
  sessionStorage.removeItem('cachedResponse');
  if (typeof window.cb === 'function' && typeof window.dayjs === 'function') {
    window.cb(window.dayjs(localStorage.getItem('start')), window.dayjs(localStorage.getItem('end')));
    return;
  }
  location.reload();
}

// Column offset from DATE_USED (the calendar's currently-rendered start date), the same formula
// the cell menu's "add"/"paste" callbacks use today.
export function dateFromColumn(column: number): string {
  const date = new Date(Date.parse(DATE_USED ?? ''));
  date.setDate(date.getDate() + column);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
